import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import stl from './NewArrivalsNotificationModal.module.css';
import { useTranslation } from "@i18n";
import Button from "@/components/UiKit/Button/Button";
import { api__updateCustomer } from "@/apis/customer/customer";
import toast from "react-hot-toast";
import { trackEvents } from "@/common/events/events";
import { CDN_LINK } from "@globalConfig";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useCookieClient from "@hooks/useCookieClient";

/** ---------------------------------------- */

/** ---------------------------------------- */

var NewArrivalsNotificationModal = function NewArrivalsNotificationModal(_ref) {
  var onClose = _ref.onClose,
    thanksModalOpen = _ref.thanksModalOpen,
    openThanksModal = _ref.openThanksModal;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSession = useSession(),
    userData = _useSession.user;
  var _useAuthActions = useAuthActions(),
    setUserData = _useAuthActions.setUserData;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var handleAcceptNotification = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var res, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return api__updateCustomer({
              opt_whatsapp_interest: 1
            });
          case 1:
            res = _context.v;
            if (res.success) {
              openThanksModal();
              setUserData(_objectSpread(_objectSpread({}, userData), {}, {
                opt_whatsapp_interest: true
              }));
              trackEvents("notification_popup_response", {
                uuid: getCookieClient("UUID"),
                popup_response: "Yes"
              });
            }
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            onClose();
            toast.error(t("error_something_went_wrong", {
              ns: "new_arrivals"
            }));
            console.log(_t);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function handleAcceptNotification() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: stl.newArrivalModalWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.upperSection
  }, thanksModalOpen ? /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/check-payment.svg",
    alt: "",
    className: stl.thanksModalIcon
  }) : /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/favorite-icon.svg",
    alt: ""
  })), thanksModalOpen ? /*#__PURE__*/React.createElement("div", {
    className: stl.thanKdownSection
  }, /*#__PURE__*/React.createElement("h3", {
    className: stl.modalHead
  }, t("thank", {
    ns: "new_arrivals"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.modalText
  }, t("notified_cars_match_favorites_added", {
    ns: "new_arrivals"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: stl.downSection
  }, /*#__PURE__*/React.createElement("h3", {
    className: stl.modalHead
  }, t("great", {
    ns: "new_arrivals"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.modalText
  }, t("like_receive_notifications_new_cars", {
    ns: "new_arrivals"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.whatsappSection
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/whatsapp-icon.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("p", {
    className: stl.whatsText
  }, t("notifications_sent_via_whatsapp", {
    ns: "new_arrivals"
  }))), /*#__PURE__*/React.createElement(Button, {
    type: 'default',
    className: stl.modalButton,
    onClick: handleAcceptNotification
  }, t("yes", {
    ns: "new_arrivals"
  }))));
};
export default NewArrivalsNotificationModal;